import { ca } from '@cian/analytics';
//@ts-expect-error no types
import { ICommandEventSiteData } from '@cian/analytics/dist/command';

export const trackVideoPlaying = (eventData: ICommandEventSiteData) => {
  ca('eventSite', eventData);
};
